"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");require("core-js/modules/es6.function.name");require("core-js/modules/es6.number.constructor");




































































































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { regionList: [], //服务区域列表
      tableData: [], // 列表数据
      droplist: [], imageSrcList: [], deviceIds: '', searchData: { deviceNo: '', supportSecretKey: '', deviceTypeName: '', //营销型号
        deviceTypeCode: '', //工厂型号
        page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, showDialog: false, deviceCode: '', newadd: false, title: '新增', addData: { regionalId: '', sn: '', deviceTypeId: '', supportSecretKey: '0', name: '' }, defaultData: { regionalId: '', sn: '', deviceTypeId: '', supportSecretKey: '0', name: '' }, // 表格列
      tableColumns: [{ prop: 'sn', label: '设备序列号', isShow: true }, { prop: 'regionalName', label: '服务区域', isShow: true }, // {
      //   prop: 'equipmentQuantity',
      //   label: '厂家型号编码',
      //   isShow: false
      // },
      { prop: 'deviceTypeName', label: '营销型号', isShow: true }, { prop: 'deviceTypeCode', label: '工厂型号', isShow: true }, { prop: 'supportSecretKey', label: '支持秘钥', formatter: _formatter.supportSecretKeyFormatter, isShow: true }, { prop: 'secretKey', label: '秘钥', isShow: false }, // {
      //   prop: 'address',
      //   label: '位置',
      //   isShow: true
      // },
      { prop: 'qrCode', label: '二维码地址', isShow: false, width: 200 }, { prop: 'operatorUser', label: '操作人', isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: true }], rules: { regionalId: [{ required: true, message: '请选择服务区域', trigger: 'change' }], sn: [{ required: true, message: '请输入设备序列号', trigger: 'change' }], deviceTypeId: [{ required: true, message: '请选择设备型号', trigger: 'change' }] }, regionalId: 0, //出库单服务区域id
      deviceTypeId: 0 //出库单设备型号id
    };}, mounted: function mounted() {this.regionalId = this.$route.params.regionalId;this.deviceTypeId = this.$route.params.deviceTypeId;var self = this;self.init();self.getdrop();self.fetchRegionList();}, methods: { /**
                                                                                                                                                                                                                           * 获取区域列表
                                                                                                                                                                                                                           */fetchRegionList: function fetchRegionList() {var _this = this;this.getData('/api/faServicesRegional/getAll', { page: 1, rows: 9999999 }, function (res) {_this.regionList = res.list;});}, init: function init() {var self = this;var url = '/api/faInstorageDetail/page/instorage/' + self.$route.params.parentId;self.getData(url, self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.deviceNo = '';this.searchData.supportSecretKey = '';this.searchData.deviceTypeName = '';this.searchData.deviceTypeCode = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, delMenu: function delMenu(item) {var self = this;self.$confirm('确定删除该记录吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(function () {self.delData('/api/faInstorageDetail/' + item.id, {}, function (res) {self.$message({ message: '删除成功!', type: 'success' });self.searchData.page = 1;self.init();});}).catch(function () {});}, addFun: function addFun() {// 新增
      this.title = '新增';this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.$set(this.addData, 'regionalId', Number(this.regionalId));
      this.$set(this.addData, 'deviceTypeId', Number(this.deviceTypeId));
      console.log('this.addData====>', this.addData);
      this.getdrop();
      this.newadd = true;
    },
    returnFun: function returnFun() {
      // 返回上一级
      this.$router.push('/device/information');
    },
    onDialogOpen: function onDialogOpen() {var _this2 = this;
      this.$nextTick(function () {
        _this2.$refs.addForm.clearValidate();
      });
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      //				document.getElementById("fileinput").value = '';
      done();
    },
    onSubmit: function onSubmit() {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          // self.addData.details = self.poplistData
          self.postData('/api/faInstorageDetail', {
            regionalId: self.addData.regionalId,
            instorageId: self.$route.params.parentId,
            supportSecretKey: self.addData.supportSecretKey,
            sn: self.addData.sn,
            deviceTypeId: self.addData.deviceTypeId },
          function (res) {
            self.$message({
              message: '新增成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    updateMenu: function updateMenu(item) {// 编辑
      this.title = '编辑';
      var self = this;
      self.getData('/api/faInstorageDetail/' + item.id, {}, function (res) {
        console.log(res);
        self.addData.id = res.id;
        self.addData.deviceTypeId = res.deviceTypeId;
        self.addData.sn = res.sn;
        self.addData.supportSecretKey = res.supportSecretKey;
        self.getdrop();
        self.newadd = true;
      });
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.putData('/api/faInstorageDetail/' + self.addData.id, self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.searchData.page = 1;
            self.init();
            self.onCencal();
          });
        } else {
          return false;
        }
      });
    },
    getdrop: function getdrop() {
      var self = this;
      self.getData('/api/faDeviceType', {
        name: self.addData.name,
        rows: 500 },
      function (res) {
        if (res.list.length > 0) {
          self.droplist = res.list;
        } else if (res.list.length == 0) {
          self.$message({
            message: '没有该设备类型，请重新搜索!',
            type: 'warning' });

          self.addData.name = '';
        }
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    get: function get(event) {
      var self = this;
      if (event.keyCode == 38 || event.keyCode == 40) return;
      self.getdrop();
    },
    handleSelectionChange: function handleSelectionChange(val) {var _this3 = this;
      var self = this;
      self.deviceIds = '';
      val.map(function (item) {
        _this3.deviceIds += item.id + ',';
      });
      console.log('this.deviceIds:', this.deviceIds);
    },
    batchUpgradeFun: function batchUpgradeFun(item, type) {
      var self = this;
      var idses = self.deviceIds.substr(0, self.deviceIds.length - 1).split(',');
      var idList = idses.map(function (el) {
        return parseInt(el);
      });
      if (idList == []) {
        this.$message({
          showClose: true,
          message: '请选择要支持秘钥的数据',
          type: 'error' });

      } else if (idses !== '') {
        self.$confirm('确定修改该记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true }).
        then(function () {
          self.putData('/api/faInstorageDetail/batchSecretKey/support', idList, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            item.enabled = type;
            self.init();
          });
        }).catch(function () {});
      }
    },
    batchNoUpgradeFun: function batchNoUpgradeFun(item, type) {
      var self = this;
      var idses = self.deviceIds.substr(0, self.deviceIds.length - 1).split(',');
      var idList = idses.map(function (el) {
        return parseInt(el);
      });
      if (idses === '') {
        this.$message({
          showClose: true,
          message: '请选择要移除的数据',
          type: 'error' });

      } else if (idses !== '') {
        self.$confirm('确定修改该记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true }).
        then(function () {
          self.putData('/api/faInstorageDetail/batchSecretKey/nonsupport', idList, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            item.enabled = type;
            self.init();
          });
        }).catch(function () {});
      }
    },
    exportMenu: function exportMenu(item) {
      var url = '/api/faInstorageDetail/' + item.id + '/downloadQrCode';
      var self = this;
      var link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('target', '_blank');
      link.click();
      // if (item.auditStatus === 1) {
      //   var link = document.createElement('a')
      //   link.setAttribute('href', url)
      //   link.setAttribute('target', '_blank')
      //   link.click()
      // } else if (item.auditStatus === 0) {
      //   self.$message({
      //     message: '该入库单号未审核的不能导出，请先审核再导出！',
      //     type: 'error'
      //   })
      //   return false
      // }
    } } };exports.default = _default;